import { captureMessage } from '@sentry/node';

export const defaultErrorHandler = (error: unknown) => {
    captureMessage(
        'failed to post api-campaign events',
        { level: 'warning', contexts: { error: { uparsed: JSON.stringify(error) } } },
    );
};
